import { render, staticRenderFns } from "./LookProduct.vue?vue&type=template&id=20a7ad92&scoped=true"
import script from "./LookProduct.vue?vue&type=script&lang=js"
export * from "./LookProduct.vue?vue&type=script&lang=js"
import style0 from "./LookProduct.vue?vue&type=style&index=0&id=20a7ad92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a7ad92",
  null
  
)

export default component.exports